export enum EnvironmentType {
    Prod,
    PPE,
    Blackforest,
    GccModerate,
    GccHigh,
    DoD,
    Gallatin,
    AG08,
    AG09
}